import BaseFeature from '../../foundation/base/base';

class FormCprNumber extends BaseFeature {
	constructor(element) {
		super(element);
		this.el = element;
		this.initDomCache();
		this.selectors = {
			cprCheckCprNumber: this.el.querySelector('[data-form-field=cprCheckCprNumber]'),
			cprCheckTelephoneParent: this.el.querySelector(
				'[data-form-field=cprCheckTelephoneParent]'
			),
		};
		this.init();
	}

	init() {
		if (this.selectors.cprCheckTelephoneParent) {
			this.selectors.cprCheckTelephoneParent.parentNode.style.display = 'none';
		}

		if (this.selectors.cprCheckCprNumber) {
			this.selectors.cprCheckCprNumber.addEventListener('change', (e) => {
				const cprObj = this.checkCPR(e.target);
				if (cprObj.age >= 15) {
					this.selectors.cprCheckTelephoneParent.parentNode.style.display = 'none';
					this.selectors.cprCheckTelephoneParent.required = false;
				} else {
					this.selectors.cprCheckTelephoneParent.parentNode.style.display = 'block';
					this.selectors.cprCheckTelephoneParent.required = true;
				}
			});
		}
	}

	// eslint-disable-next-line class-methods-use-this
	validateCPRNum(cpr) {
		// link to regex source: https://regex101.com/library/K0yPqX
		const cprRegex = /^(0[1-9]|[12]\d|3[01])(0[1-9]|1[0-2])\d{2}[-]?\d{4}$/gm;
		if (cprRegex.test(cpr)) {
			return true;
		} return false;
	}

	// eslint-disable-next-line class-methods-use-this
	getGender(cpr) {
		return cpr % 2 ? 'Male' : 'Female';
	}

	// eslint-disable-next-line class-methods-use-this
	getDate(cpr) {
		const digit7 = parseInt(cpr[6], 10);

		const dateSegments = cpr.substring(0, 6).match(/.{1,2}/g);
		let date = new Date(
			Date.UTC(
				dateSegments[2],
				dateSegments[1] - 1,
				dateSegments[0],
				0,
				0,
				0,
				0
			)
		);

		const year = date.getFullYear();
		const month = date.getMonth();
		const day = date.getDate();

		// century correction
		if (digit7 === 4 || digit7 === 9) {
			// 1900 or 2000
			if (year <= 1936) {
				date = new Date(Date.UTC(year + 100, month, day, 0, 0, 0, 0));
			}
		} else if (digit7 > 4) {
			// 1800 or 2000
			date = new Date(
				Date.UTC(year > 1957 ? year - 100 : year + 100, month, day, 0, 0, 0, 0)
			);
		}

		const dateFormat = date.toLocaleDateString('da-DK', {
			day: 'numeric',
			month: 'numeric',
			year: 'numeric',
		});
		return dateFormat;
	}

	// eslint-disable-next-line class-methods-use-this
	getAge(cpr) {
		// format to vaild date
		const dateString = cpr;
		const dateParts = dateString.split('.');
		const cprDay = parseInt(dateParts[0], 10);
		const cprMonth = parseInt(dateParts[1], 10);
		const cprYear = parseInt(dateParts[2], 10);
		// month is 0-based, that's why we need dataParts[1] - 1
		const dateObject = new Date(cprYear, cprMonth - 1, cprDay);

		const dob = new Date(dateObject);
		// calculate month difference from current date in time
		const monthDiff = Date.now() - dob.getTime();

		// convert the calculated difference in date format
		const ageDt = new Date(monthDiff);

		// extract year from date
		const year = ageDt.getUTCFullYear();

		// now calculate the age of the user
		const age = Math.abs(year - 1970);

		// display the calculated age
		return age;
	}

	// eslint-disable-next-line class-methods-use-this
	sumProduct(a, b) {
		return a.reduce((sum, digit, i) => {
			const sumProduct = sum + digit * b[i];
			return sumProduct;
		}, 0);
	}

	modulo11(cpr) {
		const multipliers = [4, 3, 2, 7, 6, 5, 4, 3, 2, 1];
		return this.sumProduct(cpr.split(''), multipliers) % 11;
	}

	isValid(cpr) {
		return this.modulo11(cpr) === 0;
	}

	getCprInfo(cpr) {
		return {
			cpr,
			valid: this.isValid(cpr),
			date: this.getDate(cpr),
			age: this.getAge(this.getDate(cpr)),
			gender: this.getGender(cpr),
		};
	}

	checkCPR(cprInput) {
		cprInput.value.replace('-', '');
		const cprValue = cprInput.value;

		const validateCPR = this.validateCPRNum(cprValue);
		if (!validateCPR) {
			return { age: 15 };
		}

		const cprObj = this.getCprInfo(cprValue);
		return cprObj;
	}
}

export default FormCprNumber;
